import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card, CardBody, Row, Col,
} from 'reactstrap';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import navigateToResetPasswordHandler from '../../../Investor/common/navigateToResetPasswordHandler';
import { loginManagedUser } from '../../../../shared/services/apiGateway';
import LoginForm from '../../../../shared/components/LoginForm';
import checkK1ConsentNudge from '../../../../shared/helpers/checkK1ConsentNudge';

const navigatingToResetPassword = () => navigateToResetPasswordHandler();
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
const LoginCard = ({
  dispatch, existingEmail, switchScreen, showCreateAccount,
}) => {
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  if (navigatingToResetPassword()) {
    switchScreen(true);
  }

  const handleFormSubmit = async (data) => {
    if (!executeRecaptcha) {
      return;
    }

    const { email, password } = data;
    setLoading(true);
    try {
      const reCaptchaToken = await executeRecaptcha('managedLogin');

      const res = await loginManagedUser({
        email,
        password,
        reCaptchaToken,
      });
      // eslint-disable-next-line eqeqeq
      if (res === false || res.success == false) {
        if (res.message !== '[500]') {
          setLoginError(true);
        }
      } else {
          if (res.resourceAccessToken && res.isMFANudgeRequired) {
            const encodedRedirect = encodeURIComponent(window.location.href);
            window.location.href =
              `${process.env.AV_VC_PATH}/mfa-setup?resourceAccessToken=${res.resourceAccessToken}&redirect=${encodedRedirect}`;
          return;  
        }
        if (res.resourceAccessToken) {
          const encodedRedirect = encodeURIComponent(window.location.href);
          window.location.href = `${process.env.AV_VC_PATH}/login/otp-challenge?resourceAccessToken=${res.resourceAccessToken}&redirect=${encodedRedirect}`;
          await sleep(2000);
          return;
        } else {
          res.user.users = res.user.managedUsers.map((usr) => ({
            ...usr, firstName: usr.firstName, lastName: usr.lastName, id: usr.id,
          }));
          dispatch({ user: res.user, authCode: res.authToken, type: 'INIT_SESSION_SUCCESS' });
        }
        setLoginError(false);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      if (error && error.message !== '[500]') {
        setLoginError(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="card--not-full-height">
      <CardBody>
        <Row className="w-100">
          <Col>
            <h3>
              <b style={{ color: 'black' }}>
                Authorized Account Login
              </b>
            </h3>
            <h5>
              Login to Alumni Ventures
            </h5>
          </Col>
        </Row>
        <hr />
        <LoginForm
          handleFormSubmit={handleFormSubmit}
          loginError={loginError}
          existingEmail={existingEmail}
          switchScreen={switchScreen}
          loading={loading}
          showCreateAccount={showCreateAccount}
        />
      </CardBody>
    </Card>
  );
};

LoginCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  existingEmail: PropTypes.string,
  switchScreen: PropTypes.func,
};

LoginCard.defaultProps = {
  existingEmail: '',
  switchScreen: null,
};

const mapStateToProps = (state) => ({
  dispatch: state.auth,
});

export default withRouter(connect(mapStateToProps)(LoginCard));
